<template>
    <b-container class="contact-in">
      <b-row class="contact-row">
        <b-col lg="8" md="8" sm="8" class="left">
          <b-col class="head w-100">
              <Headings :data="heading"/>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </template>
  <script>
//   import ContactForm from "./contact-form";
  // import LeftContent from "../common/leftContent";
  export default {
    name: "ContactIntro",
    props: ["heading", "paragraph"],
    components: {
    //   ContactForm,
      // LeftContent,
    },
  };
  </script>
  <style scoped>
  .left {
    margin-top: 5rem;
    margin-bottom: 1rem;
  }
  .center-heading{
    text-align: center;
  }
  /* Media Queries */
  /* Tablet Screens */
  @media (min-width: 1100px) and (orientation: landscape) {
    .left {
      margin-left: 22rem;

    }

  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    .left {
      height: 100vh;
      transform: translateY(12vh);
      width: 40vw;
    }
    .right {
      height: 100vh;
      margin-top: 4rem;
      width: 100%;
      transform: translateY(12vh);
    }
    .mid-col {
      display: none;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    .left {
      height: 43vh;
      transform: translateY(6vh);
    
    }
    .right {
      height: 43vh;
    }
    .mid-col {
      display: none;
    }
  }
  /* Mobile Screens */
  @media (min-width: 481px) and (max-width: 767px) {
    .left {
      height: 43vh;
      margin-top: 5rem;
      margin-right:20rem ;

       backdrop-filter: blur(4px);
    }
    /* .left {
    margin-top: 5rem;
    margin-bottom: 1rem;
  } */
    .right {
      height: 50vh;
    }
    .mid-col{
      display:none;
    }
  }
  
  @media (max-width: 480px) {
    .left {
      display:flex!important;
      align-items:center;
      backdrop-filter: blur(4px);
      margin-top: 1rem;
      padding-top: 16px;
    }
    .right {
      margin-top: 2rem;
      height: auto;
    }
  }
  </style>